import {organisationConstants } from '../_constants';

const initialState = { loading : true, organisation: '', error: false};

export function organisation(state = initialState, action) {
    switch (action.type) {
        case organisationConstants.REQUEST_ORGANISATION:
            return {
                loading: true,
                organisation: '',
                error: false
            };
        case organisationConstants.RECIEVE_ORGANISATION:
            return {
                loading: false,
                organisation: action.orgs,
                error: false
            };
        case organisationConstants.ERROR_ORGANISATION:
            return { 
                loading: false,
                organisation: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation.reducer.js